/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import Logo from './assets/img/logo.png';
import CloseIcon from './assets/icons/close-black.png';

export default function CheckUpdates() {
  const { isUpdateAvailable, reloadApp, close } = useAppUpdateChecker();

  return (
    <>
      {isUpdateAvailable && (
        <div id="update-checker" onClick={close}>
          <img src={CloseIcon} className="close-btn" alt="Logo" />
          <img src={Logo} className="logo" alt="Logo" />
          <p className="message">Nueva versión disponible</p>
          <button type="button" className="main-btn" onClick={reloadApp}>
            Actualizar
          </button>
        </div>
      )}
    </>
  );
}

function useAppUpdateChecker() {
  const CHECK_INTERVAL = 5 * 60 * 1000; // Cada 60 segundos
  const VERSION_FILE = 'static/js/version.json';

  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentVersion, setCurrentVersion] = useState(null);

  const checkRefresh = () => {
    // Verifica si ya viene de un Hot Reload
    if (window.location.href.includes('?t=')) {
      const url = new URL(window.location.href);
      url.searchParams.delete('t');
      window.location.replace(url.href);
    }
  }

  const reloadApp = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('t', Date.now().toString());
    window.location.replace(url.href);
  }

  const fetchInitialVersion = async () => {
    try {
      const res = await fetch(VERSION_FILE);
      if (res.ok) {
        const data = await res.json();
        setCurrentVersion(data.hash);
      }
    } catch (err) {
      console.warn('⚠️ No se pudo leer versión inicial', err);
    } finally {
      setIsLoading(false);
    }
  }

  const checkUpdate = async () => {
    if (isUpdateAvailable) return;
    try {
      const res = await fetch(`${VERSION_FILE}?t=${Date.now()}`, { cache: 'no-cache' });
      if (res.ok) {
        const remote = await res.json();
        if (remote.hash !== currentVersion) {
          setIsUpdateAvailable(true);
        }
      }
    } catch (err) {
      console.warn('⚠️ Error checking update', err);
    }
  }

  // Leer la versión actual (la que vino con esta carga de la app)
  useEffect(() => {
    checkRefresh();

    if (process.env.NODE_ENV === 'production') fetchInitialVersion();
  }, []);

  // Chequear periódicamente si hay nueva versión
  useEffect(() => {
    if (!currentVersion) return;

    const interval = setInterval(async () => checkUpdate(), CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [currentVersion]);

  return {
    isUpdateAvailable,
    isLoading,
    reloadApp,
    close: () => setIsUpdateAvailable(false),
  };
}